import React from "react";

import { StoreRoutes } from "./StoreRoutes";

export const Store = () => {
  return (
    <StoreRoutes />
  );
};
